import { Router } from '@dice-driven/d3-kit';

export const router = new Router();

router.addRoute('/', 'home');
router.addRoute('/miniatures', 'miniatures');
router.addRoute('/images', 'images');
router.addRoute('/images/new', 'images');
router.addRoute('/images/:id', 'images');
router.addRoute('/capsules', 'capsules');
router.addRoute('/capsules/new', 'capsules');
router.addRoute('/capsules/:id', 'capsules');
router.addRoute('/hooks', 'hooks');
router.addRoute('/hooks/new', 'hooks');
router.addRoute('/hooks/:id', 'hooks');
router.addRoute('/title-screens', 'title-screens');
router.addRoute('/title-screens/new', 'title-screens');
router.addRoute('/title-screens/:id', 'title-screens');
router.addRoute('/tactical-maps', 'tactical-maps');
router.addRoute('/tactical-maps/new', 'tactical-maps');
router.addRoute('/tactical-maps/:id', 'tactical-maps');
router.addRoute('/tile-brushes', 'tile-brushes');
router.addRoute('/tile-brushes/new', 'tile-brushes');
router.addRoute('/tile-brushes/:id', 'tile-brushes');
// Legacy redirects: the asset type was renamed wall-brush -> tile-brush
// (issue #57). Keep old bookmarks/links working by redirecting to the new path.
router.addRoute('/wall-brushes', 'tile-brushes', { redirect: '/tile-brushes' });
router.addRoute('/wall-brushes/new', 'tile-brushes', { redirect: '/tile-brushes/new' });
router.addRoute('/wall-brushes/:id', 'tile-brushes', { redirect: '/tile-brushes/:id' });
router.addRoute('/pipeline', 'pipeline');
router.addRoute('/commissions', 'commissions');
router.addRoute('/commissions/new', 'commissions');
router.addRoute('/commissions/:id', 'commissions');
router.addRoute('/commissions/:id/edit', 'commissions');
router.addRoute('/freelancers', 'freelancers');
router.addRoute('/ledger', 'ledger');
router.addRoute('/settings', 'settings');
router.addRoute('/apps', 'apps');
router.addRoute('/sync-jobs', 'sync-jobs');
router.addRoute('/freelancers/invite', 'freelancers');
router.addRoute('/available-commissions', 'available-commissions');
router.addRoute('/available-commissions/:id', 'available-commissions');
router.addRoute('/asset-catalog', 'asset-catalog');
router.addRoute('/asset-catalog/:id', 'asset-catalog');
router.addRoute('/agreements', 'agreements');
router.addRoute('/sows', 'sows');
router.addRoute('/assignments', 'assignments');
router.addRoute('/assignments/:id', 'assignments');
router.addRoute('/staff-assignments', 'staff-assignments');
router.addRoute('/staff-assignments/activity', 'staff-assignments');
router.addRoute('/staff-assignments/:id', 'staff-assignments');
